export default __webpack_public_path__ + "static/media/linkedin.f679b81a.svg";